import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class NotifyUpdateItemToResolve {
  private subject = new Subject<void | any>();
  message;

  sendMessage(message: any) {
    this.message = message;
    this.subject.next({ ...message });
  }

  clearMessages() {
    this.subject.next();
  }

  getStatus() {
    return this.message;
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
